const NEWS_ENDPOINT = "/news/";
const NEWS_LISTING_WITH_PAGE_ENDPOINT = "/news/page/:pageNumber";
const NEWS_LISTING_WITH_MAKE_ENDPOINT = "/:makeMaskingName(.+)-cars/news/";
const NEWS_LISTING_WITH_MAKE_PAGE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/news/page/:pageNumber";
const NEWS_LISTING_WITH_MAKE_MODEL_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/news/";
const NEWS_LISTING_WITH_MAKE_MODEL_PAGE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/news/page/:pageNumber";
const PIT_STOP_LISTING = "/pitstop/";
const PIT_STOP_LISTING_WITH_PAGE = "/pitstop/page/:pageNumber";
export const PIT_STOP_LISTING_ENDPOINT = [
  PIT_STOP_LISTING,
  PIT_STOP_LISTING_WITH_PAGE,
];
const HINDI_EXPERT_REVIEW_LISTING = "/hi/expert-reviews/";
const HINDI_EXPERT_REVIEW_LISTING_WITH_PAGE =
  "/hi/expert-reviews/page/:pageNumber";
export const HINDI_EXPERT_REVIEW_LISTING_ENDPOINT = [
  HINDI_EXPERT_REVIEW_LISTING,
  HINDI_EXPERT_REVIEW_LISTING_WITH_PAGE,
];
const HINDI_FEATURES_LISTING = "/hi/features/";
const HINDI_FEATURES_LISTING_WITH_PAGE = "/hi/features/page/:pageNumber";
export const HINDI_FEATURES_LISTING_ENDPOINT = [
  HINDI_FEATURES_LISTING,
  HINDI_FEATURES_LISTING_WITH_PAGE,
];
const HINDI_NEWS_LISTING = "/hi/news/";
const HINDI_NEWS_LISTING_WITH_PAGE = "/hi/news/page/:pageNumber";
export const HINDI_NEWS_LISTING_ENDPOINT = [
  HINDI_NEWS_LISTING,
  HINDI_NEWS_LISTING_WITH_PAGE,
];
const AUTOEXPO_NEWS_LISTING = "/autoexpo/2020/news/";
const AUTOEXPO_NEWS_LISTING_WITH_PAGE = "/autoexpo/2020/news/page/:pageNumber";
export const AUTOEXPO_NEWS_LISTING_ENDPOINT = [
  AUTOEXPO_NEWS_LISTING,
  AUTOEXPO_NEWS_LISTING_WITH_PAGE,
];

export const NEWS_LISTING_ENDPOINT = [
  NEWS_ENDPOINT,
  NEWS_LISTING_WITH_PAGE_ENDPOINT,
  NEWS_LISTING_WITH_MAKE_ENDPOINT,
  NEWS_LISTING_WITH_MAKE_PAGE_ENDPOINT,
  NEWS_LISTING_WITH_MAKE_MODEL_ENDPOINT,
  NEWS_LISTING_WITH_MAKE_MODEL_PAGE_ENDPOINT,
];
const REVIEWS_ENDPOINT = "/expert-reviews/";
const REVIEWS_LISTING_WITH_PAGE_ENDPOINT = "/expert-reviews/page/:pageNumber";
const REVIEWS_LISTING_WITH_MAKE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/expert-reviews/";
const REVIEWS_LISTING_WITH_MAKE_PAGE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/expert-reviews/page/:pageNumber";
const REVIEWS_LISTING_WITH_MAKE_MODEL_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/expert-reviews/";
const REVIEWS_LISTING_WITH_MAKE_MODEL_PAGE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/expert-reviews/page/:pageNumber";
export const REVIEWS_LISTING_ENDPOINT = [
  REVIEWS_ENDPOINT,
  REVIEWS_LISTING_WITH_PAGE_ENDPOINT,
  REVIEWS_LISTING_WITH_MAKE_ENDPOINT,
  REVIEWS_LISTING_WITH_MAKE_PAGE_ENDPOINT,
  REVIEWS_LISTING_WITH_MAKE_MODEL_ENDPOINT,
  REVIEWS_LISTING_WITH_MAKE_MODEL_PAGE_ENDPOINT,
];
const SPECIAL_REPORTS_ENDPOINT = "/features/";
const SPECIAL_REPORTS_LISTING_WITH_PAGE_ENDPOINT = "/features/page/:pageNumber";
const SPECIAL_REPORTS_LISTING_WITH_MAKE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/features/";
const SPECIAL_REPORTS_LISTING_WITH_MAKE_PAGE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/features/page/:pageNumber";
const SPECIAL_REPORTS_LISTING_WITH_MAKE_MODEL_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/features/";
const SPECIAL_REPORTS_LISTING_WITH_MAKE_MODEL_PAGE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/features/page/:pageNumber";
export const SPECIAL_REPORTS_LISTING_ENDPOINT = [
  SPECIAL_REPORTS_ENDPOINT,
  SPECIAL_REPORTS_LISTING_WITH_PAGE_ENDPOINT,
  SPECIAL_REPORTS_LISTING_WITH_MAKE_ENDPOINT,
  SPECIAL_REPORTS_LISTING_WITH_MAKE_PAGE_ENDPOINT,
  SPECIAL_REPORTS_LISTING_WITH_MAKE_MODEL_ENDPOINT,
  SPECIAL_REPORTS_LISTING_WITH_MAKE_MODEL_PAGE_ENDPOINT,
];
const IMAGES_ENDPOINT = "/images/";
const IMAGES_LISTING_WITH_PAGE_ENDPOINT = "/images/page/:pageNumber";
const IMAGES_WITH_QUERY_PARAMETERS_ENDPOINT = "/images/?(.+)";
const IMAGES_WITH_PAGE_QUERY_PARAMETERS_ENDPOINT =
  "/images/page/:pageNumber/?(.+)";

export const IMAGES_LISTING_ENDPOINT = [
  IMAGES_ENDPOINT,
  IMAGES_LISTING_WITH_PAGE_ENDPOINT,
  IMAGES_WITH_QUERY_PARAMETERS_ENDPOINT,
  IMAGES_WITH_PAGE_QUERY_PARAMETERS_ENDPOINT,
];
const VIDEOS_ENDPOINT = "/videos/";
const VIDEOS_LISTING_WITH_PAGE_ENDPOINT = "/videos/page/:pageNumber";
const VIDEOS_LISTING_WITH_MAKE_ENDPOINT = "/:makeMaskingName(.+)-cars/videos/";
const VIDEOS_LISTING_WITH_MAKE_PAGE_ENDPOINT =
  "/:makeMaskingName(.+)-cars/videos/page/:pageNumber";
const VIDEOS_LISTING_WITH_MAKE_MODEL_ENDPOINT =
  "/:makeMaskingName(.+)-cars/videos/?(.+)";

export const VIDEOS_LISTING_ENDPOINT = [
  VIDEOS_ENDPOINT,
  VIDEOS_LISTING_WITH_PAGE_ENDPOINT,
  VIDEOS_LISTING_WITH_MAKE_ENDPOINT,
  VIDEOS_LISTING_WITH_MAKE_PAGE_ENDPOINT,
  VIDEOS_LISTING_WITH_MAKE_MODEL_ENDPOINT,
];

export const PAGE_TYPE = {
  NEWS_LISTING: 1,
  EXPERT_REVIEWS_LISTING: 2,
  FEATURE_LISTING: 6,
  IMAGES_LISTING: 10,
  PIT_STOP_LISTING: 12,
  VIDEOS_LISTING: 13,
  HINDI_NEWS_LISTING: 31,
  HINDI_EXPERT_REVIEW_LISTING: 32,
  HINDI_FEATURES_LISTING: 33,
  AUTOEXPO_NEWS_LISTING: 1.8,
};
